module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","events":"Seminare","publicEventOverview":"Öffentliche Schulinungsübersicht"},"en":{"add":"Add","events":"Events","publicEventOverview":"Public event overview"}}')
  delete Component.options._Ctor
}
